import { BrowseSearchQueryParams, BrowseSearchResults } from '../types';
import apiRequest from './apiRequest';

export default async function postPoseBrowseSearch(
  params: BrowseSearchQueryParams,
  signal?: AbortSignal,
) {
  const { data, error } = await apiRequest<BrowseSearchResults>(
    'mogen-orchestration',
    '/v2/poseSearch',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    signal,
  );
  return { data, error };
}
